import * as yup from 'yup'

const decisionWithQualityValidationSchema = yup.object().shape({
    decisionNature: yup
        .string()
        .required('L\'Org. doit être selectionnée.'),
    decisionQuality: yup
        .string()
        .when('decisionNature', {
            is: (decisionNature: string) => ["AG Extraordinaire", "AG Ordinaire", "AG Mixte"].includes(decisionNature),
            then: (schema) => schema.required('Qualité de l\'org. doit être selectionnée.'),
            otherwise: (schema) => schema.notRequired()
        }),
    decisionDate: yup
        .string()
        .required('La date de décision est requise')
        .matches(/^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/([0-9]{4})$/, 'Veuillez saisir une date au format JJ/MM/AAAA'),
    effectiveDate: yup
        .string()
        .required('La date effective est requise')
        .matches(/^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/([0-9]{4})$/, 'Veuillez saisir une date au format JJ/MM/AAAA'),
});

export default decisionWithQualityValidationSchema;